import { useLocation } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { useIsVideoAnalyticsEnabled } from "@/react/components/SettingsApp/Analytics/useIsVideoAnalyticsEnabled";
import { useIsSitesEnabled } from "@/react/components/SettingsApp/Site/Pages/useIsSitesEnabled";
import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers";
import { NavGroup } from "../NavGroup";
import { SubNavLinkItem } from "./SubNavLinkItem";
import type { Link } from "./types";

export const AnalyticsLinks = () => {
  const location = useLocation();
  const isSitesEnabled = useIsSitesEnabled();
  const isVideoAnalyticsEnabled = useIsVideoAnalyticsEnabled();
  const links: Link[] = [
    {
      label: t("settings_nav_v3.analytics_v2.overview"),
      path: settingsNavPathV3.analytics_v2.index,
      exact: true,
    },
    {
      label: t("settings_nav_v3.analytics_v2.members"),
      path: settingsNavPathV3.analytics_v2.members,
      exact: true,
    },
    ...(isSitesEnabled
      ? [
          {
            label: t("settings_nav_v3.analytics_v2.website"),
            path: settingsNavPathV3.analytics_v2.website,
            exact: true,
          },
        ]
      : []),
    ...(isVideoAnalyticsEnabled
      ? [
          {
            label: t("settings_nav_v3.analytics_v2.videos"),
            path: settingsNavPathV3.analytics_v2.videos,
            exact: true,
          },
        ]
      : []),
    {
      label: t("settings_nav_v3.analytics_v2.spaces"),
      path: settingsNavPathV3.analytics_v2.spaces,
      exact: true,
    },
    {
      label: t("settings_nav_v3.analytics_v2.post_comments"),
      path: settingsNavPathV3.analytics_v2.post_comments,
      exact: true,
    },
    {
      label: t("settings_nav_v3.analytics_v2.messages"),
      path: settingsNavPathV3.analytics_v2.messages,
      exact: true,
    },
    {
      label: t("settings_nav_v3.analytics_v2.devices"),
      path: settingsNavPathV3.analytics_v2.devices,
      exact: true,
    },
    {
      label: t("settings_nav_v3.analytics_v2.events"),
      path: settingsNavPathV3.analytics_v2.events,
      exact: true,
    },
    {
      label: t("settings_nav_v3.analytics_v2.payments"),
      path: settingsNavPathV3.analytics_v2.payments,
      exact: true,
    },
    {
      label: t("settings_nav_v3.analytics_v2.courses"),
      path: settingsNavPathV3.analytics_v2.courses,
      exact: true,
    },
  ];
  return (
    <NavGroup groupLinks={links}>
      <NavGroup.Content title={t("settings_nav_v3.analytics_v2.label")}>
        {links.map(link => (
          <SubNavLinkItem
            key={link.label}
            label={link.label}
            path={{
              pathname: link.path,
              search: location.search,
            }}
          />
        ))}
      </NavGroup.Content>
    </NavGroup>
  );
};
